import React from 'react';
import { JcCommonProps, JcSize, JcUtils } from '../utils/JcUtils';

export interface JcImageProps extends JcCommonProps {
  readonly size: JcSize;
  readonly url: string;
  readonly alt: string;
  readonly circle?: boolean;
  /** Responsive candidates, e.g. `"thumb.webp 800w, full.webp 2000w"`; pair with `sizes`. */
  readonly srcSet?: string;
  readonly sizes?: string;
  /** Intrinsic pixel dimensions — reserve the image's space before it loads (no layout shift). */
  readonly width?: number;
  readonly height?: number;
  /** Defer loading until near the viewport; use for below-the-fold images. */
  readonly lazy?: boolean;
}

export const JcImage: React.FunctionComponent<JcImageProps> = (props: JcImageProps) => {
  const { size, url, alt, circle, srcSet, sizes, width, height, lazy } = props;
  const commonProps = JcUtils.commonProps(props, [
    "jc-image",
    size !== JcSize.NONE && ("jc-image-size-" + size),
    circle && "jc-image-circle",
  ]);

  return (
    <img
      {...commonProps}
      alt={alt}
      src={url}
      srcSet={srcSet}
      sizes={sizes}
      width={width}
      height={height}
      loading={lazy ? "lazy" : undefined}
      decoding={lazy ? "async" : undefined}
    />
  );
}
